import axiosInstance from "../../../axios";

export const getOffers = async (payload) => {
  console.log(payload, "payloaddOne");
  try {
    const response = await axiosInstance.get(
      `/offers?limit=${payload?.limit}&page=${payload?.page}`
    );
    return response.data.payload;
  } catch (error) {
    console.log(error);
  }
};

export const addOffer = async (payload) => {
  try {
    const response = await axiosInstance.post("/offers/add", payload);
    console.log(response);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};


export const editOffer = async (payload) => {
  try {
    const response = await axiosInstance.patch(`/offers/${payload?.id}`, payload?.obj);
    console.log(response);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};



export const getOffer = async (payload) => {
  try {
    const response = await axiosInstance.get(`/offers/${payload}`);
    console.log(response,'finalRes');
    return response.data;
  } catch (error) {
    console.log(error);
  }
};


export const offerPublish = async (id, payload) => {
  try {
    const response = await axiosInstance.patch(`/offers/${id}`, payload);
    console.log(response);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const offerDetails = async (payload) => {
  try {
    console.log(payload, "payloadd");
    const response = await axiosInstance.get(
      `/offers/redeemed/${payload?.id}?limit=${payload?.limit}&page=${payload?.page}&month=${payload?.month}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getReferral = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/referral?limit=${payload?.limit}&page=${payload?.page}&date=${payload?.month}`
    );
    console.log("apihit");
    return response.data.payload;
  } catch (error) {
    console.log(error);
  }
};
